import { v2Request } from "../helpers/request";

export const getConversionList = () => {
  return v2Request(`/chats/list`);
};

export const getChatMessages = (chatId: number) => {
  return v2Request(`/chats/messages/${chatId}`);
};

export const fetchUnreadMessages = () => {
  return v2Request(`/chats/unread`);
};

export const markChatAsRead = (chatId: number) => {
  // This will be implemented with socket.io
  return { chatId };
};

export const deleteChat = (chatId: number) => {
  return v2Request(`/chats/${chatId}`, {
    method: "DELETE",
  });
};
